// document.addEventListener('DOMContentLoaded', function() {
//   const partnersSections = document.querySelectorAll('.comp-our-partners');
  
//   partnersSections.forEach(function(section) {
//     const logosContainer = section.querySelector('.comp-our-partners__logos');
//     if (!logosContainer) return;
    
//     // Only apply marquee on mobile
//     if (window.innerWidth <= 1050) {
//       setupMarquee(logosContainer);
//     }
    
//     // Handle resize
//     window.addEventListener('resize', function() {
//       if (window.innerWidth <= 1050 && !logosContainer.classList.contains('marquee-initialized')) {
//         setupMarquee(logosContainer);
//       } else if (window.innerWidth > 1050) {
//         logosContainer.classList.remove('marquee-initialized');
//         logosContainer.style.animation = 'none';
//       }
//     });
//   });
  
//   function setupMarquee(container) {
//     // Check if already initialized
//     if (container.classList.contains('marquee-initialized')) return;
    
//     // Clone logos for seamless looping
//     const logos = container.querySelectorAll('.comp-our-partners__logo');
//     logos.forEach(function(logo) {
//       const clone = logo.cloneNode(true);
//       container.appendChild(clone);
//     });
    
//     // Calculate duration based on number of logos
//     const logoCount = logos.length;
//     const duration = logoCount * 3; // 3 seconds per logo
    
//     // Apply animation
//     container.style.animation = `marquee ${duration}s linear infinite`;
//     container.classList.add('marquee-initialized');
//   }
  
//   // Handle Shopify editor
//   if (typeof Shopify !== 'undefined' && Shopify.designMode) {
//     document.addEventListener('shopify:section:load', function(event) {
//       const section = event.target.querySelector('.comp-our-partners');
//       if (section) {
//         const logosContainer = section.querySelector('.comp-our-partners__logos');
//         if (logosContainer && window.innerWidth <= 1050) {
//           setupMarquee(logosContainer);
//         }
//       }
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const partnersSections = document.querySelectorAll('.comp-our-partners');

  partnersSections.forEach(function (section) {
    const logosContainer = section.querySelector('.comp-our-partners__logos');
    if (!logosContainer) return;

    setupMarquee(logosContainer);
  });

  function setupMarquee(container) {
    // Prevent double init
    if (container.classList.contains('marquee-initialized')) return;

    const logos = Array.from(
      container.querySelectorAll('.comp-our-partners__logo')
    );

    // Clone once for seamless loop
    logos.forEach(function (logo) {
      container.appendChild(logo.cloneNode(true));
    });

    // Duration based on original logos only
    const duration = logos.length * 3; // seconds per logo

    container.style.animation = `marquee ${duration}s linear infinite`;
    container.classList.add('marquee-initialized');
  }

  /* Shopify Theme Editor support */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.querySelector('.comp-our-partners');
      if (!section) return;

      const logosContainer = section.querySelector('.comp-our-partners__logos');
      if (logosContainer) {
        setupMarquee(logosContainer);
      }
    });
  }
});
